import { Component, Inject, OnInit } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-dialog-dynamic-notifications',
    templateUrl: './dialog-dynamic-notifications.component.html',
    styles: [],
    standalone: false
})
export class DialogDynamicNotificationsComponent implements OnInit {
  public isMobile: boolean;
  doNotShowAgain: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<DialogDynamicNotificationsComponent>,
    @Inject(MAT_DIALOG_DATA) public data
    ) {
      this.isMobile = environment.platform === 'mobile';
    }

  ngOnInit() { }

  setNewValue(event) {
    this.data.newValueCheck = event.checked;
  }
}
